.inlineHtmlWrapper a,
.inlineHtmlWrapper abbr,
.inlineHtmlWrapper acronym,
.inlineHtmlWrapper address,
.inlineHtmlWrapper applet,
.inlineHtmlWrapper b,
.inlineHtmlWrapper big,
.inlineHtmlWrapper blockquote,
.inlineHtmlWrapper body,
.inlineHtmlWrapper button,
.inlineHtmlWrapper caption,
.inlineHtmlWrapper center,
.inlineHtmlWrapper cite,
.inlineHtmlWrapper code,
.inlineHtmlWrapper dd,
.inlineHtmlWrapper del,
.inlineHtmlWrapper dfn,
.inlineHtmlWrapper div,
.inlineHtmlWrapper dl,
.inlineHtmlWrapper dt,
.inlineHtmlWrapper em,
.inlineHtmlWrapper embed,
.inlineHtmlWrapper fieldset,
.inlineHtmlWrapper figure,
.inlineHtmlWrapper font,
.inlineHtmlWrapper form,
.inlineHtmlWrapper html,
.inlineHtmlWrapper i,
.inlineHtmlWrapper iframe,
.inlineHtmlWrapper img,
.inlineHtmlWrapper ins,
.inlineHtmlWrapper kbd,
.inlineHtmlWrapper label,
.inlineHtmlWrapper legend,
.inlineHtmlWrapper li,
.inlineHtmlWrapper object,
.inlineHtmlWrapper ol,
.inlineHtmlWrapper p,
.inlineHtmlWrapper pre,
.inlineHtmlWrapper q,
.inlineHtmlWrapper s,
.inlineHtmlWrapper samp,
.inlineHtmlWrapper small,
.inlineHtmlWrapper span,
.inlineHtmlWrapper strike,
.inlineHtmlWrapper strong,
.inlineHtmlWrapper table,
.inlineHtmlWrapper tbody,
.inlineHtmlWrapper td,
.inlineHtmlWrapper tfoot,
.inlineHtmlWrapper th,
.inlineHtmlWrapper thead,
.inlineHtmlWrapper tr,
.inlineHtmlWrapper tt,
.inlineHtmlWrapper u,
.inlineHtmlWrapper ul {
  padding: 0;
  margin: 0;
  border: 0;
  outline: 0;
  font-family: var(--cxy-font-family-sans);
  font-size: var(--cxy-fontSize-s);
  font-weight: var(--cxy-fontWeight-normal);
  color: var(--cxy-color-midnight-blue-700);
  background: 0 0;
}

/* Specific styles for headings ----------------------------------- */
.inlineHtmlWrapper h1:not(:only-child):not(:last-child),
.inlineHtmlWrapper h2:not(:only-child):not(:last-child),
.inlineHtmlWrapper h3:not(:only-child):not(:last-child),
.inlineHtmlWrapper h4:not(:only-child):not(:last-child),
.inlineHtmlWrapper h5:not(:only-child):not(:last-child),
.inlineHtmlWrapper h6:not(:only-child):not(:last-child),
.inlineHtmlWrapper h1:not(:only-child):not(:last-child) b,
.inlineHtmlWrapper h2:not(:only-child):not(:last-child) b,
.inlineHtmlWrapper h3:not(:only-child):not(:last-child) b {
  font-weight: var(--cxy-fontWeight-extraBold);
  padding: 16px 0 8px;
}

/* Remove top padding if heading is the first child */
.inlineHtmlWrapper h1:first-child:not(:only-child):not(:last-child) {
  padding-top: 0;
}

.inlineHtmlWrapper h1:not(:only-child):not(:last-child),
.inlineHtmlWrapper h1:not(:only-child):not(:last-child) b {
  font-size: var(--cxy-fontSize-xxl);
  line-height: var(--cxy-lineHeight-xl);
}

.inlineHtmlWrapper h2:not(:only-child):not(:last-child),
.inlineHtmlWrapper h2:not(:only-child):not(:last-child) b {
  font-size: var(--cxy-fontSize-xl);
  line-height: var(--cxy-lineHeight-l);
}

.inlineHtmlWrapper h3:not(:only-child):not(:last-child),
.inlineHtmlWrapper h3:not(:only-child):not(:last-child) b {
  font-size: var(--cxy-fontSize-l);
  line-height: var(--cxy-lineHeight-l);
}

.inlineHtmlWrapper h1:not(:only-child):not(:last-child) {
  padding: 0 0 8px;
}

/* Top padding for first h2 in container */
.inlineHtmlWrapper h2:first-child:not(:only-child):not(:last-child) {
  padding: 32px 0 8px;
}

.inlineHtmlWrapper h4:not(:only-child):not(:last-child),
.inlineHtmlWrapper h5:not(:only-child):not(:last-child),
.inlineHtmlWrapper h6:not(:only-child):not(:last-child) {
  font-size: var(--cxy-fontSize-m);
  line-height: var(--cxy-lineHeight-m);
}

:global(:root) {
  --cx-anchor-offset: 72px; /* mobile (<1025px) — confirmed good */
}
@media (min-width: 1025px) {
  :global(:root) {
    --cx-anchor-offset: calc(48px + 70px); /* 2 levels: primary + secondary = 118px */
  }
  :global(:root:has([data-testid='tertiary-header-nav-section'])) {
    --cx-anchor-offset: calc(48px + 70px + 36px); /* 3 levels: + tertiary = 154px */
  }
}
.inlineHtmlWrapper :is(h1, h2, h3, h4, h5, h6)[id] {
  scroll-margin-top: var(--cx-anchor-offset);
}

/* Paragraph and list styles ----------------------------------------- */
.inlineHtmlWrapper p {
  line-height: var(--cxy-lineHeight-m);
  margin-bottom: 16px;
}
.inlineHtmlWrapper b,
.inlineHtmlWrapper strong {
  font-weight: var(--cxy-fontWeight-bold);
}

.inlineHtmlWrapper ul {
  padding-left: 8px;
  list-style: disc inside;
  margin-left: 14px;
  margin-bottom: 16px;
}

.inlineHtmlWrapper ul li {
  display: list-item;
  list-style: disc;
  margin-bottom: 8px;
}

.inlineHtmlWrapper ol {
  padding-left: 12px;
  list-style: decimal inside;
  margin-left: 14px;
  margin-bottom: 16px;
}

.inlineHtmlWrapper ol li {
  display: list-item;
  list-style: decimal;
  margin-bottom: 8px;
}

/* Link styles ------------------------------------------------------ */
.inlineHtmlWrapper p a:link,
.inlineHtmlWrapper ul li a:link {
  text-decoration: underline;
  font-weight: var(--cxy-fontWeight-bold);
}

.inlineHtmlWrapper p a b {
  font-weight: var(--cxy-fontWeight-bold);
}

.inlineHtmlWrapper h3 a,
.inlineHtmlWrapper h3 a i,
.inlineHtmlWrapper h3 a i b,
.inlineHtmlWrapper h4 a,
.inlineHtmlWrapper h4 a i,
.inlineHtmlWrapper h4 a i b {
  font-weight: var(--cxy-fontWeight-bold);
}

.inlineHtmlWrapper h4 {
  font-size: 18px;
}

/* Image styles ----------------------------------------------------- */

/* Default large images that fill the parent */
.inlineHtmlWrapper img {
  width: 100%;
  height: auto;
  object-fit: cover;
}

.inlineHtmlWrapper img[class*='small-image'] {
  max-width: 160px;
  max-height: 50px;
  border-radius: 3px;
  object-fit: contain;
}

.inlineHtmlWrapper img[class*='medium-image'] {
  max-width: 320px;
  max-height: 180px;
  border-radius: 5px;
  object-fit: contain;
}

.inlineHtmlWrapper img[class*='left-aligned'] {
  display: block;
}

.inlineHtmlWrapper img[class*='right-aligned'] {
  display: block;
  margin-left: auto;
}

.inlineHtmlWrapper img[class*='middle-aligned'] {
  display: block;
  margin-inline: auto;
}

/* Table styles ----------------------------------------------------- */
.inlineHtmlWrapper table {
  display: inline-table;
  min-width: 100%;
  border: 1px solid var(--cxy-color-midnight-blue-600);
  border-radius: 8px;
  border-spacing: 0;
  overflow: hidden;
}

.inlineHtmlWrapper table thead,
.inlineHtmlWrapper table tbody {
  display: table-row-group;
  vertical-align: middle;
  unicode-bidi: isolate;
}

.inlineHtmlWrapper th,
.inlineHtmlWrapper td {
  vertical-align: middle;
  unicode-bidi: isolate;
  overflow: hidden;
}

.inlineHtmlWrapper .no-borders {
  border-collapse: collapse !important;
  border: none !important;
  width: 100% !important;

  th,
  td {
    border: none !important;
  }
}

.inlineHtmlWrapper .no-headers thead,
.inlineHtmlWrapper .no-headers th {
  display: none !important;
}

/* Target the first column of all tables */
.inlineHtmlWrapper table td:first-child,
.inlineHtmlWrapper table th:first-child {
  width: 150px;

  @media (min-width: 768px) {
    width: 300px;
  }
}

.inlineHtmlWrapper th:first-child {
  border-top-left-radius: 5px;
}

.inlineHtmlWrapper th:last-child {
  border-top-right-radius: 5px;
}

.inlineHtmlWrapper tr:last-child td:first-child {
  border-bottom-left-radius: 5px;
}

.inlineHtmlWrapper tr:last-child td:last-child {
  border-bottom-right-radius: 5px;
}

.inlineHtmlWrapper tr:has(th) {
  background-color: #ccc;
  color: var(--cxy-color-white);
  font-weight: var(--cxy-fontWeight-bold);
  text-transform: uppercase;
}

.inlineHtmlWrapper tr:has(th) * {
  color: var(--cxy-color-black);
  font-weight: var(--cxy-fontWeight-bold);
  text-transform: uppercase;
}

.inlineHtmlWrapper tr:not(:has(th)):nth-child(odd) {
  background-color: var(--cxy-color-grey-200);
}

.inlineHtmlWrapper tr:not(:has(th)):nth-child(even) {
  background-color: var(--cxy-color-white);
}

.inlineHtmlWrapper th:not(:has(*)),
.inlineHtmlWrapper th > * {
  margin: 0;
  padding: 5px;
  font-size: var(--cxy-fontSize-xs);

  @media (min-width: 768px) {
    font-size: var(--cxy-fontSize-s);
  }
}

.inlineHtmlWrapper td:not(:has(*)) {
  line-height: var(--cxy-lineHeight-xxs);
  padding: 0 8px;
  color: var(--cxy-color-black);
  font-weight: var(--cxy-fontWeight-normal);
  font-size: var(--cxy-fontSize-xs);

  @media (min-width: 768px) {
    font-size: var(--cxy-fontSize-s);
  }
}

.inlineHtmlWrapper td:has(*) > * {
  vertical-align: middle;
  line-height: var(--cxy-lineHeight-xxs);
  margin: 0;
  padding: 8px;
  color: var(--cxy-color-black);
  font-weight: var(--cxy-fontWeight-normal);
  font-size: var(--cxy-fontSize-xs);

  @media (min-width: 768px) {
    font-size: var(--cxy-fontSize-s);
  }
}

.inlineHtmlWrapper iframe {
  width: 100%;
  overflow: hidden;
  margin-bottom: 8px;
}

/* Temp solution to handle legacy table structures for ES, BR and IT during transition =================================== */
.inlineHtmlWrapper table[class*='custom-table'],
.inlineHtmlWrapper table[class*='custom-table'] tbody,
.inlineHtmlWrapper table[class*='custom-table'] tbody tr,
.inlineHtmlWrapper table[class*='custom-table'] tbody tr[class*='header'],
.inlineHtmlWrapper table[class*='custom-table'] tbody tr[class*='header'] th,
.inlineHtmlWrapper table[class*='custom-table'] tbody tr td,
.inlineHtmlWrapper table[class*='custom-table'] tbody tr td a {
  text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: transparent;
  font-family: inherit;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.1px;
  line-height: 28px;
  text-align: justify;
}

.inlineHtmlWrapper table tbody,
.inlineHtmlWrapper table tbody * {
  color: var(--cxy-color-midnight-blue-600);
}

.inlineHtmlWrapper table[class*='custom-table'] {
  display: block !important;
  border: none;
  border-collapse: collapse;
  border-spacing: 0;
  box-sizing: border-box;
  border-radius: 8px;
  margin: 10px 0;
  max-width: 100%;
  overflow-x: auto;
  width: 100% !important;
}

.inlineHtmlWrapper table[class*='custom-table'] tbody {
  border-spacing: 0;
  border-collapse: collapse;
}

.inlineHtmlWrapper table[class*='custom-table'] tbody tr {
  background-color: var(--cxy-color-grey-75);
  border-left: 1px solid #e6eaed;
  border-right: 1px solid #e6eaed;
}

.inlineHtmlWrapper table[class*='custom-table'] tbody tr:nth-child(even) {
  background-color: #fff;
}

.inlineHtmlWrapper table[class*='custom-table'] tbody tr[class*='header'],
.inlineHtmlWrapper table[class*='custom-table'] thead tr {
  background-color: var(--cxy-color-midnight-blue-600);
  color: #fff;
}

.inlineHtmlWrapper table[class*='custom-table'] tbody tr[class*='header'] th,
.inlineHtmlWrapper table[class*='custom-table'] thead tr th {
  color: #fff;
  font-weight: normal;
  font-style: normal;
  padding: 8px;
  border: none;
  text-align: center;
  vertical-align: middle;
}

.inlineHtmlWrapper table[class*='custom-table'] thead tr th * {
  color: #fff;
  text-align: center;
  vertical-align: middle;
  font-weight: normal;
  font-style: normal;
}

.inlineHtmlWrapper table[class*='custom-table'] tbody tr td {
  text-align: center;
  vertical-align: middle;
  padding: 10px 5px;
}

.inlineHtmlWrapper table[class*='custom-table'] tbody tr td img,
.inlineHtmlWrapper table[class*='custom-table'] tbody tr td img[class*='logo'] {
  max-height: 40px;
  border-radius: 4px;
  max-width: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  padding: 0;
}

.inlineHtmlWrapper table[class*='custom-table'] tbody tr td strong {
  font-weight: bold;
}

.inlineHtmlWrapper table[class*='custom-table'] tbody tr td a {
  border-spacing: 0;
  border-collapse: collapse;
  font-family: inherit;
  text-align: center;
  font-weight: bold;
  -webkit-tap-highlight-color: transparent;
  background: transparent;
  text-decoration: underline;
}

.inlineHtmlWrapper table tr td:only-child {
  background-color: #e6eaed;
}

.inlineHtmlWrapper table[class*='custom-table'] tbody tr td a[class*='button-link'] {
  padding: 8px;
  border-radius: 4px;
  text-decoration: none;
  white-space: nowrap;
  background-color: var(--cxy-color-green-400);
}

/* ==== Table Theme - table-v1 first theme to unify table styles for all regions with shared composable table structure ==== */

/* table-v1 wrapper - contains table and optional footer div */
.inlineHtmlWrapper div[class*='table-v1'] {
  display: block;
  width: 100%;
}

/* table-v1 table base */
.inlineHtmlWrapper div[class*='table-v1'] > table {
  width: 100%;
  border-left: 1px solid #e6eaed;
  border-right: 1px solid #e6eaed;
  border-bottom: 1px solid #e6eaed;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 0px;
  background-color: #fff;
  overflow: visible;
  table-layout: fixed;
}

/* Enable horizontal scrolling on mobile for wide tables */
@media (max-width: 767px) {
  .inlineHtmlWrapper div[class*='table-v1'] {
    overflow-x: auto;
    max-width: calc(100vw - 32px);
  }

  .inlineHtmlWrapper div[class*='table-v1'] > table {
    table-layout: auto;
  }
}

.inlineHtmlWrapper div[class*='table-v1']:not(:has(> div[class*='table-footer'])) > table {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.inlineHtmlWrapper div[class*='table-v1']:has(> div[class*='table-footer']) > table {
  border-bottom: none;
}

/* When extra-width exists: switch to auto layout to control column widths */
.inlineHtmlWrapper div[class*='table-v1']:has(td[class*='extra-width']) > table {
  table-layout: auto;
}

/* caption - Used for the table Title heading and spans full width of table */
.inlineHtmlWrapper div[class*='table-v1'] table caption {
  display: table-caption;
  caption-side: top;
  width: 100%;
  min-height: 52px;
  padding: 16px 16px;
  margin: 0;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-left: 1px solid var(--cxy-color-midnight-blue-600);
  border-right: 1px solid var(--cxy-color-midnight-blue-600);
  border-top: 1px solid var(--cxy-color-midnight-blue-600);
  color: #fff;
  background-color: var(--cxy-color-midnight-blue-600);
  font-weight: var(--cxy-fontWeight-bold);
  font-size: var(--cxy-fontSize-m);
  text-align: center;
  line-height: var(--cxy-lineHeight-m);
}

/* thead - optional header row with column titles */
.inlineHtmlWrapper div[class*='table-v1'] > table > thead {
  display: table-header-group;
}

.inlineHtmlWrapper div[class*='table-v1'] > table > thead tr {
  background-color: #e6eaed;
  padding: 0px 12px;
}

.inlineHtmlWrapper div[class*='table-v1'] > table > thead th {
  padding: 8px;
  text-align: center;
  vertical-align: middle;
  color: var(--cxy-color-midnight-blue-600);
  font-weight: var(--cxy-fontWeight-bold);
  font-size: var(--cxy-fontSize-s);
  border: none;
  border-radius: 0px;
}

/* text alignment overrides */
.inlineHtmlWrapper div[class*='table-v1'] > table > thead th[class*='td-left-aligned'] {
  text-align: left;
  margin-right: auto;
}

.inlineHtmlWrapper div[class*='table-v1'] > table > thead th[class*='td-right-aligned'] {
  text-align: right;
  margin-left: auto;
}

/* Extra-width cell takes remaining space */
.inlineHtmlWrapper div[class*='table-v1'] > table > thead th[class*='extra-width'] {
  width: 100%;
}

/* All other cells shrink to content */
.inlineHtmlWrapper div[class*='table-v1'] > table > thead th:not([class*='extra-width']) {
  width: auto;
  white-space: nowrap;
}

/* tbody - table data rows */
.inlineHtmlWrapper div[class*='table-v1'] > table > tbody {
  display: table-row-group;
}

.inlineHtmlWrapper div[class*='table-v1'] > table > tbody tr:nth-child(odd) {
  background-color: var(--cxy-color-grey-75);
}

.inlineHtmlWrapper div[class*='table-v1'] > table > tbody tr:nth-child(even) {
  background-color: #fff;
}

.inlineHtmlWrapper div[class*='table-v1'] > table > tbody tr td {
  width: auto;
  padding: 8px;
  text-align: center;
  vertical-align: middle;
  color: var(--cxy-color-midnight-blue-600);
  font-weight: var(--cxy-fontWeight-normal);
  font-size: var(--cxy-fontSize-xs);
}

.inlineHtmlWrapper div[class*='table-v1'] > table > tbody tr:not(:has(img)):not(:has(a[class*='button-link'])) > td {
  padding: 16px 8px;
}

@media (min-width: 768px) {
  .inlineHtmlWrapper div[class*='table-v1'] > table > tbody tr td {
    padding: 8px 18px;
    font-size: var(--cxy-fontSize-s);
  }

  .inlineHtmlWrapper div[class*='table-v1'] > table > tbody tr:not(:has(img)):not(:has(a[class*='button-link'])) > td {
    padding: 16px 18px;
  }

  .inlineHtmlWrapper div[class*='table-v1'] > table > thead th {
    padding: 8px 18px;
    font-size: var(--cxy-fontSize-s);
  }
}

.inlineHtmlWrapper div[class*='table-v1'] > table > tbody td a {
  text-decoration: underline;
}

/* Button Link ------------------------------ */
.inlineHtmlWrapper div[class*='table-v1'] > table tbody tr td a[class*='button-link'] {
  display: inline-block;
  padding: 11px 10px;
  border-radius: 4px;
  text-decoration: none;
  white-space: nowrap;
  background-color: var(--cxy-color-green-400);
  font-weight: var(--cxy-fontWeight-bold);
  font-size: var(--cxy-fontSize-s);
}

.inlineHtmlWrapper div[class*='table-v1'] > table tbody tr td a[class*='button-link']:hover {
  background-color: #66f1b8;
}

.inlineHtmlWrapper div[class*='table-v1'] > table tbody tr td a[class*='button-link']:disabled {
  background-color: var(--cxy-color-grey-200);
  color: #666666;
}

.inlineHtmlWrapper div[class*='table-v1'] > table > tbody td a:hover {
  cursor: pointer;
}

.inlineHtmlWrapper div[class*='table-v1'] > table > tbody tr td bold {
  padding: 0px;
  font-weight: var(--cxy-fontWeight-bold);
}

.inlineHtmlWrapper div[class*='table-v1'] > table > thead th:first-child,
.inlineHtmlWrapper div[class*='table-v1'] > table > tbody tr td:first-child {
  width: auto;
}

/* text and content alignment overrides */
.inlineHtmlWrapper div[class*='table-v1'] > table > tbody td[class*='td-left-aligned'] {
  text-align: left;
}

.inlineHtmlWrapper div[class*='table-v1'] > table > tbody td[class*='td-left-aligned'] * {
  display: block;
  margin-right: auto;
  margin-left: 0;
}

.inlineHtmlWrapper div[class*='table-v1'] > table > tbody td[class*='td-right-aligned'] {
  text-align: right;
}

.inlineHtmlWrapper div[class*='table-v1'] > table > tbody td[class*='td-right-aligned'] * {
  display: block;
  margin-left: auto;
  margin-right: 0;
}

/* Extra-width td cell: takes remaining space */
.inlineHtmlWrapper div[class*='table-v1'] > table > tbody tr td[class*='extra-width'] {
  width: 100%;
}

/* Non-extra-width td cells when extra-width exists: shrink to content */
.inlineHtmlWrapper
  div[class*='table-v1']
  > table
  > tbody
  tr:has(td[class*='extra-width'])
  td:not([class*='extra-width']) {
  width: auto;
}

.inlineHtmlWrapper
  div[class*='table-v1']
  > table
  > tbody
  tr:has(td[class*='extra-width'])
  td:not([class*='extra-width'])
  img {
  min-width: 107px;
}

.inlineHtmlWrapper
  div[class*='table-v1']
  > table
  > tbody
  tr:has(td[class*='extra-width'])
  td:not([class*='extra-width'])
  bold {
  min-width: 150px;
}

@media (min-width: 768px) {
  .inlineHtmlWrapper
    div[class*='table-v1']
    > table
    > tbody
    tr:has(td[class*='extra-width'])
    td:not([class*='extra-width'])
    bold {
    min-width: 250px;
  }
}

/* last row border-radius - only when NO footer exists */
.inlineHtmlWrapper
  div[class*='table-v1']:not(:has(> div[class*='table-footer']))
  > table
  > tbody
  tr:last-child
  td:first-child {
  border-bottom-left-radius: 8px;
}

.inlineHtmlWrapper
  div[class*='table-v1']:not(:has(> div[class*='table-footer']))
  > table
  > tbody
  tr:last-child
  td:last-child {
  border-bottom-right-radius: 8px;
}

/* image logo styling */
.inlineHtmlWrapper div[class*='table-v1'] > table img[class*='logo'] {
  max-height: 40px;
  width: auto;
  max-width: 107px;
  border-radius: 4px;
  max-width: 100%;
  height: auto;
  object-fit: contain;
  padding: 0;
}

/* table footer - optional div below table, separate from table structure */
.inlineHtmlWrapper div[class*='table-v1'] > div[class*='table-footer'] {
  display: block;
  text-align: center;
  background-color: #e6eaed;
  border-radius: 0 0 8px 8px;
  border-left: 1px solid #e6eaed;
  border-right: 1px solid #e6eaed;
  border-bottom: 1px solid #e6eaed;
}

.inlineHtmlWrapper div[class*='table-v1'] > div[class*='table-footer'] a {
  color: var(--cxy-color-midnight-blue-600);
  text-decoration: none;
  display: block;
  padding: 10px 16px;
  align-items: center;
}

.inlineHtmlWrapper div[class*='table-v1'] > div[class*='table-footer'] a span {
  font-weight: var(--cxy-fontWeight-semiBold);
  font-size: var(--cxy-fontSize-m);
}

.inlineHtmlWrapper div[class*='table-v1'] > div[class*='table-footer'] a:hover {
  cursor: pointer;
}

.inlineHtmlWrapper div[class*='table-v1'] > div[class*='table-footer'] a span[class*='footer-link-arrow'] {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-bottom: 1px;
  border-top: 1px solid var(--cxy-color-midnight-blue-600);
  border-right: 1px solid var(--cxy-color-midnight-blue-600);
  transform: rotate(45deg);
}

/* Table Tick and Cross */

.inlineHtmlWrapper div[class*='table-v1'] > table > tbody td span[class*='td-tick']::before {
  content: '✓';
  color: #008b52;
  font-size: 20px;
  font-weight: bold;
}

.inlineHtmlWrapper div[class*='table-v1'] > table > tbody td span[class*='td-cross']::before {
  content: '✕';
  color: #ff435a;
  font-size: 20px;
  font-weight: bold;
}
